import {
	SET_WIDGETS,
	CREATE_WIDGET,
	UPDATE_WIDGET,
	DELETE_WIDGET,
	CLEAR_WIDGETS,
} from '../actions/actionTypes';
import { tryParse } from 'utils';

const preState = [];

const mapGroupIDs = groups => groups.map(el => (el.id ? el.id : el));

export const widgetsReducer = (state = preState, action) => {
	const stateDup = [...state];
	const { type, widgets, widget, widgetID, index } = action;
	switch (type) {
		case SET_WIDGETS:
			return [
				...widgets
					.filter(widget => widget.id !== 0)
					.map(widget => {
						const props = tryParse(widget.props) || {};
						const groupIDs = mapGroupIDs(widget.groups);
						return { ...widget, props, groups: groupIDs };
					}),
			];
		case CLEAR_WIDGETS:
			return [];
		case CREATE_WIDGET:
			return stateDup.map((w, i) => {
				const props = tryParse(widget.props) || {};
				const groupIDs = mapGroupIDs(widget.groups);
				return i === index ? { ...widget, props, groups: groupIDs } : w;
			});
		case UPDATE_WIDGET:
			const { id, groups } = widget;
			const props = tryParse(widget.props) || {};
			const groupIDs = mapGroupIDs(groups);
			const updatedList = stateDup.map(w => {
				return id === w.id ? { ...w, ...widget, props, groups: groupIDs } : w;
			});
			return updatedList;
		case DELETE_WIDGET:
			const removedList = stateDup.filter(w => widgetID !== w.id);
			return removedList;
		default:
			return state;
	}
};

export default widgetsReducer;
